import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import parse from 'html-react-parser';
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceDetail from "../../../components/maintenance/detail/detail";
// Components
import FilesList from "../../../components/filesList/filesList";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as pushNotificationsActions from "../../../redux/actions/pushNotifications";
// Utils
import { 
  formatDateToMadridTime, formatPushNotificationActions,
} from "../../../utils/formatters";
// Styles
import "./detail.css";

const PushNotificationsDetail = () => {
  const dispatch = useDispatch();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage); 
  const user = useSelector(state => state.authReducer.user);

  // Set constants
  const page = "push_notifications";
  const primaryName = !!detail && !!detail.title ? detail.title : ``;
  const itemNameSingular = "Notificació push";

  // Get id from url
  const { id: paramId } = useParams();
  const id = parseInt(paramId);
  // console.log('id', id);
  
  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
    // Set initial breadscrum
    const pathKey = 'detail';
    const path = `${page}/${pathKey}/${id}`;
    dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, itemNameSingular, }])); 
  }, []);

  const renderDetail = () => {
    // console.log('renderDetail > detail', detail);
    if (!detail) return null;
    return (
      <div className="push-notifications-detail-cards-wrapper">
        {renderMainCard()}
        {renderFilesList()}
      </div>
    );
  };

  const renderMainCard = () => {
    return (
      <div className="maintenance-detail-card push-notifications-detail-card">
        <div className="title maintenance-detail-title">
          {detail.title}
        </div>
        {renderField("Id", detail.id)}
        {/* {renderField("Habilitat", detail.enabled ? "SI" : "NO")}    */}
        {renderField("Títol", detail.title)}
        {renderField("Descripció", detail.body)}
        {/* {renderField("Data", formatDateToMadridTime(detail.date, true))}
        {renderField("Hora de llançament", detail.time)} */}
        {renderField("Acció", formatPushNotificationActions(detail.action))}
        {renderField("Referència Id per l'acció", !!detail.action_reference_id ? detail.action_reference_id : "")}
        {renderField("Enviada", detail.sent ? "SI" : "NO")}   
        <Box h={"20px"}></Box>            
        {renderField("Data de creació", formatDateToMadridTime(detail.creation_date))}
        {renderField("Usuari de creació", detail.creation_user)}
        {renderField("Data última modificació", formatDateToMadridTime(detail.last_modification_date))}
        {renderField("Usuari última modificació", detail.last_modification_user)}
      </div>
    );
  };

  const renderFilesList = () => {
    const url_image_1 = !!detail.url_image_1 ? parse(`<a href="${detail.url_image_1}" target="_blank">${detail.url_image_1}</a>`) : "";
    return (
      <div className="maintenance-detail-filelist-card">
        <Box className="maintenance-detail-label">
          Imatge
        </Box>
        {!!url_image_1 && (
          <Box mt="3px" className="maintenance-detail-field">
            {url_image_1}
          </Box>       
        )}             
        <FilesList
          type={"push_notification"}
          id={id}
          id2={"1"}
          setIsLoading={setIsLoading}
          label={""}
        />     
      </div>
    );
  };

  const renderField = (label, value) => {
    return (
      <div className="maintenance-detail-field-parent">
        <Box className="maintenance-detail-label" w={"220px"}>
          {label}
        </Box>    
        <Box className="maintenance-detail-field">
          {value}
        </Box>         
      </div>
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="push-notifications-detail-content">
        <MaintenanceDetail 
          primaryValue={id}
          primaryName={primaryName}
          menuConfig={{
            buttonEdit: { visible: !!user && user.grants.push_notifications },
            buttonDelete: { visible: !!user && user.grants.push_notifications },
          }}
          itemNameSingular={itemNameSingular}
          itemIsMale={false}
          actions={pushNotificationsActions} 
          setIsLoading={setIsLoading}
          renderDetail={renderDetail}
          setDetail={setDetail}
          page={"push_notifications"}
        />
      </div>
    </MainLayout>
  );
};

export default PushNotificationsDetail;
